module.exports = __webpack_public_path__ + "img/menu.b0eb8eb4.svg";